import React from "react";

const Spinner = () => {
    return( 
        <p>Loading...</p>
    );
}

export default Spinner;
